module.exports = __webpack_public_path__ + "img/logo.a2c90570.png";